import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexFlow: 'column',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    marginTop: '2%',
  },
  root: {
    display: 'flex',
    flexFlow: 'column',
    width: '100%',
    padding: '2% 0 3% 0%',
  },
  top: {
    display:'flex',
    justifyContent:'space-between',
  }
});
